import { Eye, X } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { usePlanPreview } from '@/contexts/PlanPreviewContext';

/**
 * Banda permanente mientras la vista demo está activa. Deja claro que lo que
 * se ve es una simulación de presentación, no la cuenta de un cliente real.
 */
export default function PlanPreviewBanner() {
  const { isPreviewing, label, exitPreview } = usePlanPreview();

  if (!isPreviewing) return null;

  return (
    <div
      data-testid="plan-preview-banner"
      role="status"
      className="sticky top-0 z-[60] w-full bg-amber-500 text-amber-950 px-3 py-2 flex items-center gap-2 text-xs sm:text-sm font-semibold shadow-md"
    >
      <Eye className="h-4 w-4 shrink-0" aria-hidden="true" />
      <span className="truncate">{label}</span>
      <span className="hidden sm:inline font-normal opacity-80">
        · simulación visual, sin cambios en datos reales
      </span>
      <Button
        type="button"
        size="sm"
        variant="ghost"
        data-testid="plan-preview-exit"
        onClick={exitPreview}
        className="ml-auto h-8 gap-1 text-amber-950 hover:bg-amber-600/40"
      >
        <X className="h-4 w-4" aria-hidden="true" />
        Salir de vista demo
      </Button>
    </div>
  );
}
